import React from 'react';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { hasPermission } from '../../../../../../infrastructure/utils/has-permissions';
import { Permission } from '../../../../../../api/roles.dao';
import { PREVIEW_TEXT } from '../../../_connections/connections.texts';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import { getKnovioPresentationUrlById, getOneclickStartLivestreamLinkById } from '../../../../../../infrastructure/utils/knovio.utils';
import { BaseConnectionDetailsPopoverContentProps } from './types';
import { KnovioLabel } from '../../../../../../api/connections.dao';


type KnovioConnectionDetailsPopoverContentProps = Omit<BaseConnectionDetailsPopoverContentProps, 'onLinkClick'> & {
    onOpenKnovioPreviewLinkPopover: () => void;
};

export const KnovioConnectionDetailsPopoverContent = (props: KnovioConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onCopyBtnClick, onOpenKnovioPreviewLinkPopover } = props;
    const {
        embedCodeId,
        knovioName,
        podiumLink,
        podiumAccessCode,
        podiumEmbedCode
    } = connection;

    const labels = connectionsDetailsLabels();

    const hasPreviewKnovioPermission = hasPermission(Permission.PREVIEW_KNOVIO_CONNECTION);

    const knovioLink = getKnovioPresentationUrlById(embedCodeId);
    const oneclickStartLivestreamLink = getOneclickStartLivestreamLinkById(embedCodeId);

    return (
        <>
            {hasPreviewKnovioPermission && <div className='connection-list__header'>
                <DefaultButton
                    className='prominent-button'
                    text={<FormattedMessage {...PREVIEW_TEXT} />}
                    onClick={onOpenKnovioPreviewLinkPopover}
                />
            </div>}
            <div className='connection-list__field'>{KnovioLabel.Project} {labels.EMBED_CODE_ID()}:<br />
                <TextWithCopyBtn message={embedCodeId} handleCopyClick={onCopyBtnClick} />
            </div>
            {knovioLink && <div className='connection-list__field'>{KnovioLabel.Project} {labels.LINK()}:<br />
                <TextWithCopyBtn message={knovioLink} handleCopyClick={onCopyBtnClick} />
            </div>}
            {knovioName && <div className='connection-list__field'>{KnovioLabel.Project} {labels.NAME()}:<br />
                <TextWithCopyBtn message={knovioName} handleCopyClick={onCopyBtnClick} />
            </div>}
            {oneclickStartLivestreamLink && <div className='connection-list__field'>{labels.ONECLICK_START_LIVESTREAM_LINK()}:<br />
                <TextWithCopyBtn message={oneclickStartLivestreamLink} handleCopyClick={onCopyBtnClick} />
            </div>}
            {podiumLink && <div className='connection-list__field'>{labels.KNOVIO_PODIUM_LINK()}:<br />
                <TextWithCopyBtn message={podiumLink} handleCopyClick={onCopyBtnClick} />
            </div>}
            {podiumAccessCode && <div className='connection-list__field'>{labels.KNOVIO_PODIUM_ACCESS_CODE()}:<br />
                <TextWithCopyBtn message={podiumAccessCode} handleCopyClick={onCopyBtnClick} />
            </div>}
            {podiumEmbedCode && <div className='connection-list__field'>{labels.KNOVIO_PODIUM_EMBED_CODE()}:<br />
                <TextWithCopyBtn message={podiumEmbedCode} handleCopyClick={onCopyBtnClick} />
            </div>}

        </>
    );
};
